export function Metric({ label, value, tone = "neutral", testId }) {
  return (
    <div className="metric" data-testid={testId}>
      <span className="label">{label}</span>
      <strong className={`mono metric-value ${tone}`}>{value}</strong>
    </div>
  );
}